// Use shared engraving configuration
// Ensure engraving-config.js is loaded before this file
const CONSTANTS = window.EngravingConfig || {
  MAX_IMAGE_WIDTH: 320
};

// Use CNC allowlist from engraving-config.js (only chars the machine can engrave)
var sanitizeEngravingInput = window.sanitizeEngravingInput || function (str) {
  if (typeof str !== 'string') return '';
  var allowed = (window.ENGRAVING_ALLOWED_CHARS || '') + '\n|';
  return Array.from(str).filter(function (c) { return allowed.indexOf(c) !== -1; }).join('');
};

// Map cart property name (e.g. "Engraving | Switch 2a (Above)") to overlay span data-name
// (e.g. "position 2a (above)"). The optional trailing letter is the a/b suffix for a
// grouped/split pair of switches sharing one physical gang.
function propertyNameToSpanDataName(propertyName) {
  if (!propertyName) return '';
  var match = propertyName.match(/Switch\s*(\d+[a-z]?)\s*\((Above|Below)\)/i);
  if (match) {
    return 'position ' + match[1] + ' (' + match[2].toLowerCase() + ')';
  }
  return propertyName;
}

// Sync all property-item inputs to their overlay spans (for when edit view is shown)
function syncBasketInputsToSpans(propertiesBox) {
  var itemId = propertiesBox.getAttribute('data-item-id');
  if (!itemId) return;
  propertiesBox.querySelectorAll('.property-item input').forEach(function (input) {
    var parent = input.closest('.property-item');
    var propertyName = parent.getAttribute('data-name');
    var spanDataName = propertyNameToSpanDataName(propertyName);
    var engravingSpans = propertiesBox.querySelectorAll('.engraving-overlay .engraving-span[data-name="' + spanDataName + '"]');
    var displayValue = input.value.replace(/\|/g, '\n');
    engravingSpans.forEach(function (span) {
      span.innerHTML = displayValue.replace(/\n/g, '<br>');
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (event) {
    var box = event.target.closest('.properties-box');
    if (!box) return;

    var editBtn = event.target.closest('#edit-button');
    if (editBtn && box.contains(editBtn)) {
      event.preventDefault();
      toggleEdit(true, editBtn);
      return;
    }

    var saveBtn = event.target.closest('#save-button');
    if (saveBtn && box.contains(saveBtn)) {
      event.preventDefault();
      toggleEdit(false, saveBtn);
      saveProperties(saveBtn);
      return;
    }

    var removeBtn = event.target.closest('[data-non_engraved_variant_id]');
    if (removeBtn && box.contains(removeBtn)) {
      event.preventDefault();
      removeProperties(event, removeBtn);
    }
  });

  document.querySelectorAll('.property-item input').forEach(function (input) {
    var parent = input.closest('.property-item');
    var propertyName = parent.getAttribute('data-name');
    var spanDataName = propertyNameToSpanDataName(propertyName);
    var propertiesBox = parent.closest('.properties-box');
    var itemId = propertiesBox.getAttribute('data-item-id');
    var engravingSpans = propertiesBox.querySelectorAll('.engraving-overlay .engraving-span[data-name="' + spanDataName + '"]');

    // Set the spans initially
    engravingSpans.forEach(function (span) {
      var displayValue = input.value.replace(/\|/g, '\n');
      span.innerHTML = displayValue.replace(/\n/g, '<br>');
    });

    // Update the spans on input; restrict to printable Unicode (no emojis)
    input.addEventListener('input', function () {
      var raw = input.value;
      var sanitized = sanitizeEngravingInput(raw);
      if (sanitized !== raw) {
        input.value = sanitized;
      }
      var displayValue = input.value.replace(/\|/g, '\n');
      engravingSpans.forEach(function (span) {
        span.innerHTML = displayValue.replace(/\n/g, '<br>');
      });
      checkSpanLines(propertiesBox);
    });
    input.addEventListener('paste', function (e) {
      e.preventDefault();
      var pasted = (e.clipboardData || window.clipboardData).getData('text');
      var sanitizedPasted = sanitizeEngravingInput(pasted);
      var start = this.selectionStart;
      var end = this.selectionEnd;
      var value = this.value;
      this.value = value.slice(0, start) + sanitizedPasted + value.slice(end);
      this.setSelectionRange(start + sanitizedPasted.length, start + sanitizedPasted.length);
      var displayValue = this.value.replace(/\|/g, '\n');
      engravingSpans.forEach(function (span) {
        span.innerHTML = displayValue.replace(/\n/g, '<br>');
      });
      checkSpanLines(propertiesBox);
    });
  });

  // Initial check on load
  document.querySelectorAll('.properties-box').forEach(function (propertiesBox) {
    checkSpanLines(propertiesBox);
    scaleFontSize(propertiesBox);
  });
});

function removeProperties(event, buttonFromClick) {
  var button =
    buttonFromClick ||
    (event.target && event.target.closest('[data-non_engraved_variant_id]')) ||
    event.currentTarget;
  if (!button || typeof button.closest !== 'function') return;
  var propertiesBox = button.closest('.properties-box');
  if (!propertiesBox) return;
  var nonEngravedVariantId = propertiesBox.getAttribute('data-non-engraved-variant-id');
  var lineItemId = propertiesBox.getAttribute('data-item-index');
  // No known non-engraved variant to swap to — re-adding anything else risks putting the
  // Engraved variant back with no properties. Do nothing.
  if (!nonEngravedVariantId) return;

  // Remove the current item
  CartJS.removeItem(lineItemId, {
    success: function () {
      // Add the non-engraved variant
      CartJS.addItem(nonEngravedVariantId, 1, {}, {
        success: function () {
          location.reload(); // Reload the page on success
        },
        error: function () {
          console.error('Failed to add non-engraved variant.');
        }
      });
    },
    error: function () {
      console.error('Failed to remove engraved item.');
    }
  });
}

function toggleEdit(edit, button) {
  var propertiesBox = button.closest('.properties-box');
  var propertiesPreview = propertiesBox.querySelector('.engraving-preview');
  propertiesPreview.style.display = edit ? 'block' : 'none';

  if (edit) {
    syncBasketInputsToSpans(propertiesBox);
    scaleFontSize(propertiesBox);
  }

  var items = propertiesBox.querySelectorAll('.property-item');
  items.forEach(function (item) {
    var input = item.querySelector('input');
    var span = item.querySelector('span');
    if (edit) {
      item.classList.add('editable');
      input.style.display = 'inline';
      span.style.display = 'none';
      item.style.display = 'flex';
    } else {
      span.innerText = input.value;

      item.classList.remove('editable');
      input.style.display = 'none';
      span.style.display = 'inline';

      if (input.value.trim() === '') {
        item.classList.add('empty');
        item.style.display = 'none';
      } else {
        item.classList.remove('empty');
      }
    }
  });
  propertiesBox.querySelector('#edit-button').style.display = edit ? 'none' : 'inline';
  propertiesBox.querySelector('#save-button').style.display = edit ? 'inline' : 'none';

  // Use a timeout to ensure spans are fully rendered before checking their heights
  setTimeout(function () {
    checkSpanLines(propertiesBox);
  }, 100);
}

function saveProperties(button) {
  var propertiesBox = button.closest('.properties-box');
  var propertyItems = propertiesBox.querySelectorAll('.property-item');
  var properties = {};

  var blankPlaceholder = (typeof window.ENGRAVING_BLANK_PLACEHOLDER !== 'undefined') ? window.ENGRAVING_BLANK_PLACEHOLDER : ' ';
  propertyItems.forEach(function (item) {
    // Must match cart line item property keys from add-to-cart (e.g. "Switch 1 (Above)"), not translated label text
    var propertyKey = item.getAttribute('data-name');
    if (!propertyKey) return;
    var value = item.querySelector('input').value.trim();
    // Use placeholder for empty so Shopify keeps the property when updating (Cart API omits empty strings)
    properties[propertyKey] = value !== '' ? value : blankPlaceholder;
  });

  var lineItemId = propertiesBox.getAttribute('data-item-index');

  CartJS.updateItem(lineItemId, 1, properties);
}

function checkSpanLines(propertiesBox) {
  var spans = propertiesBox.querySelectorAll('.engraving-overlay > span');
  var spansValid = true;

  var colsCount = parseInt(propertiesBox.getAttribute('data-cols-count'));
  var rowsCount = parseInt(propertiesBox.getAttribute('data-rows-count'));
  var plateHeight = parseFloat(propertiesBox.getAttribute('data-plate-height'));
  var topOffsetAbove = parseFloat(propertiesBox.getAttribute('data-top-offset-above'));
  var topOffsetBelow = parseFloat(propertiesBox.getAttribute('data-top-offset-below'));
  var verticalGap = parseFloat(propertiesBox.getAttribute('data-vertical-gap'));
  var twoLineShiftMode = propertiesBox.getAttribute('data-two-line-shift-mode') || 'below';

  // Track which rows have 2-line text (for 'above' and 'below' spans separately)
  var rowsOverTwoLinesAbove = {};
  var rowsOverTwoLinesBelow = {};

  spans.forEach(function (span, index) {
    // Reset border
    span.style.border = 'none';

    // Get the scale factor from the transform (if applied)
    var transform = window.getComputedStyle(span).transform;
    var scaleFactor = 1;
    if (transform && transform !== 'none') {
      var scaleMatch = transform.match(/scale\(([\d.]+)\)/);
      if (scaleMatch) {
        scaleFactor = parseFloat(scaleMatch[1]);
      }
    }

    // Check if the span is over two lines
    var lineHeight = parseInt(window.getComputedStyle(span).lineHeight) / scaleFactor;
    var spanHeight = span.clientHeight / scaleFactor;

    // Track which rows have 2+ lines (for both above and below spans)
    if (spanHeight > lineHeight * 2) {
      var idMatch = span.id.match(/engraving-span-[^-]+-[^-]+-(\d+)/);
      if (idMatch) {
        var switchNum = parseInt(idMatch[1]);
        var rowIdx = Math.floor((switchNum - 1) / colsCount);
        if (span.classList.contains('above')) {
          rowsOverTwoLinesAbove[rowIdx] = true;
        } else if (span.classList.contains('below')) {
          rowsOverTwoLinesBelow[rowIdx] = true;
        }
      }
    }
    
    // 3+ lines shows error
    if (spanHeight > lineHeight * 3) {
      span.style.border = '1px dashed red';
      spansValid = false;
      propertiesBox.querySelector('.engraving-error-message').style.display = 'block';
    }
  });

  // Only adjust inline top when preview is visible (otherwise heights are 0 and we set wrong values)
  var preview = propertiesBox.querySelector('.engraving-preview');
  var previewVisible = preview && window.getComputedStyle(preview).display !== 'none';

  if (previewVisible && plateHeight && !isNaN(plateHeight)) {
    // Clear all inline top first so CSS positions win unless we explicitly set for 2-line
    spans.forEach(function (span) {
      span.style.top = '';
    });
    if (twoLineShiftMode !== 'none') {
      spans.forEach(function (span) {
        var isAbove = span.classList.contains('above');
        var isBelow = span.classList.contains('below');
        var shouldShift = (twoLineShiftMode === 'both') ||
                          (twoLineShiftMode === 'above' && isAbove) ||
                          (twoLineShiftMode === 'below' && isBelow);
        if (!shouldShift) return;
        var idMatch = span.id.match(/engraving-span-[^-]+-[^-]+-(\d+)/);
        if (idMatch) {
          var switchNum = parseInt(idMatch[1]);
          var rowIdx = Math.floor((switchNum - 1) / colsCount);
          var baseTopOffset = isAbove ? topOffsetAbove : topOffsetBelow;
          var baseTop = baseTopOffset + (verticalGap * rowIdx);
          var rowHasTwoLines = isAbove ? rowsOverTwoLinesAbove[rowIdx] : rowsOverTwoLinesBelow[rowIdx];
          if (rowHasTwoLines) {
            var adjustedTop = baseTop - 6;
            span.style.top = (adjustedTop / plateHeight * 100) + '%';
          }
        }
      });
    }
  } else {
    // When preview hidden: clear inline top so CSS positions always win (fixes top: 0% override)
    spans.forEach(function (span) {
      span.style.top = '';
    });
  }

  var checkbox = propertiesBox.querySelector('.engraving-agreement');
  var saveButton = propertiesBox.querySelector('#save-button');
  if (spansValid) {
    checkbox.disabled = false;
    saveButton.disabled = false;
    propertiesBox.querySelector('.engraving-error-message').style.display = 'none';
  } else {
    checkbox.checked = false;
    checkbox.disabled = true;
    saveButton.disabled = true;
  }
}

function scaleFontSize(propertiesBox) {
  var engravingImage = propertiesBox.querySelector('.engraving-preview-container');
  var imageWidth = Math.min(engravingImage.clientWidth, CONSTANTS.MAX_IMAGE_WIDTH);
  
  // Calculate scale factor based on image width vs plate width
  // Reference: 400px image = 146mm plate (standard reference)
  var plateWidth = parseFloat(propertiesBox.getAttribute('data-plate-width'));
  var referenceImageWidth = 400;
  var referencePlateWidth = 146;
  var baseScaleFactor = (imageWidth / plateWidth) / (referenceImageWidth / referencePlateWidth);
  
  // Calibration constant: adjusts for font rendering and base size calibration
  // Measured: "Engraving" was 85.43px, should be 74.28px → ratio = 0.869
  var calibrationFactor = 0.869;
  var scaleFactor = baseScaleFactor * calibrationFactor;
  
  // Apply transform scale for uniform scaling (more accurate than font-size scaling)
  propertiesBox.querySelectorAll('.engraving-overlay > span').forEach(function (span) {
    // Set base max-width at reference scale (in mm converted to pixels at reference)
    // Compensate for calibration factor: make it larger so after scaling it's correct
    var maxWidthMm = parseFloat(span.getAttribute('data-max-width'));
    var baseMaxWidth = maxWidthMm * (referenceImageWidth / referencePlateWidth);
    // Compensate for calibration: divide by calibration factor so scaled result is correct
    span.style.maxWidth = (baseMaxWidth / calibrationFactor) + 'px';
    
    // Apply scale transform (combine with translateX(-50%) from CSS)
    // Use 'center top' origin so scaling doesn't affect vertical positioning
    span.style.transform = 'translateX(-50%) scale(' + scaleFactor + ')';
    span.style.transformOrigin = 'center top';
  });
}